import React, { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { urlHasParam } from "../../utils/js/params";
import slider from "./Slider";
import news from "./News";
import content from "./Content";

const COMPONENT_TYPE_MAPPING = { slider, news, content }

const RelatedContentSection = props => {
	const { componentType } = props;
	const Component = COMPONENT_TYPE_MAPPING[componentType] || (() => null)
	return <ErrorBoundary fallback={props.isInEditor || urlHasParam('wcmmode=disabled') ? <div style={{
		minHeight: '50px', display: 'flex', alignItems: 'center', backgroundColor: '#ffe1db'
	}}><p>The related content component is currently experiencing errors. Please try again later.</p></div> : null}>
		<Suspense fallback={<></>}><Component {...props} /></Suspense>
	</ErrorBoundary>
}

export default RelatedContentSection;
